@import '../../../../../constants/spacing.module.less';

.status-container {
  height: 24px;
  display: inline-flex;
  align-items: center;
  padding: @space-4 @space-8;
  border-radius: 4px;
  width: auto;
}

.status-container-draft {
  border: 1px solid var(--gray-E4E5E7);
  background-color: var(--gray-F1F2F3);
}

.status-container-open {
  background-color: var(--blue-e5ebff);
  border: 1px solid var(--blue-6AC7FF);
}

.status-container-received {
  border: 1px solid var(--green-05b45e);
  background-color: var(--green-EEFFF5);
}

.status-container-cancelled {
  border: 1px solid var(--purple-f8dede);
  background-color: var(--purple-f8dede);
}

.status-container-closed {
  border: 1px solid var(--gray-E4E5E7);
}

.status-container-receiving {
  border: 1px solid var(--purple-cab1ff);
  background-color: var(--purple-F6F2FF);
}

.status-dot {
  display: inline-block;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  margin-right: @space-8;
}

.status-dot-draft {
  background-color: var(--gray-56595D);
}

.status-dot-open {
  background-color: var(--blue-1D5AD8);
}

.status-dot-received {
  background-color: var(--green-007733);
}

.status-dot-cancelled {
  background-color: var(--red-FF4422);
}

.status-dot-receiving {
  background-color: var(--purple-600);
}
